import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerColorsPage from "../pages/DsokCustomerColorsPage";

export const dsokCustomerColorsRoute = {
  path: "/dsok/customer-detail/:customerUrl/colors",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerColorsPage} />
    </DsokCustomerDetailProvider>
  ),
};
